// GETTERS
export const POSITIONS_TO_SHOW = 'positions/POSITIONS_TO_SHOW'
export const PARAMS_TO_SEND = 'positions/PARAMS_TO_SEND'

// MUTATIONS
export const SET_POSITIONS = 'positions/SET_POSITIONS'
export const SET_PAGINATION = 'positions/SET_PAGINATION'
export const SET_TOTAL_ITEMS = 'positions/SET_TOTAL_ITEMS'
export const SET_IS_LOADING = 'positions/SET_IS_LOADING'
export const SET_FILTERS = 'positions/SET_FILTERS'
export const SET_ACCOUNTS = 'positions/SET_ACCOUNTS'
export const SET_CLEAR_ACCOUNTS = 'positions/SET_CLEAR_ACCOUNTS'

// ACTIONS
export const GET_POSITIONS = 'positions/GET_POSITIONS'
export const CHANGE_PAGINATION = 'positions/CHANGE_PAGINATION'
export const CHANGE_FILTERS = 'positions/CHANGE_FILTERS'
export const RESET_PAGINATION = 'positions/RESET_PAGINATION'
export const GET_ACCOUNTS = 'positions/GET_ACCOUNTS'
